import { useCallback, useContext } from 'react';
import { styled } from '@/UI/theme.exports';
import { XIcon } from '@/UI/Icons/XIcon';
import { FlexCenHorVer } from '@/UI/styles';
import { useBanner, APP_BANNER_ID } from '@/hooks/useBanner';
import { AuthContext } from '@/contexts/AuthContext';
import { ZIndex } from '@/consts/z-indexes.consts';
import { HolidayPromoBanner } from './HolidayPromoBanner.tsx';

interface AppBannerProps {
  shouldDisplayClose?: boolean;
  onClick?: () => void;
}
const StyledXIcon = styled(XIcon)(({ theme }) => ({
  position: 'absolute',
  right: 10,
  top: 10,
  color: 'black',
  cursor: 'pointer',
  [theme.breakpoints.up('sm')]: {
    top: 'auto',
  },
}));

export const AppBanner = ({ shouldDisplayClose = true, onClick }: AppBannerProps) => {
  const { currentUser } = useContext(AuthContext);
  const isUserLoggedIn = currentUser !== null;
  const { isVisible, offset, closeBanner } = useBanner(APP_BANNER_ID);

  const handleClose = useCallback(
    (event: React.MouseEvent<SVGElement>) => {
      event.stopPropagation();
      closeBanner();
    },
    [closeBanner],
  );

  if (!isVisible) {
    return null;
  }
  return (
    <FlexCenHorVer
      sx={{
        backgroundColor: '#D0D0FF',
        color: '#101012',
        p: 1.25,
        zIndex: ZIndex.Overlays.STICKY_TOP_BANNER,
        position: 'sticky',
        height: `${offset}px`,
        top: 0,
        width: '100vw',
      }}
      onClick={onClick}
    >
      <HolidayPromoBanner />
      {shouldDisplayClose && isUserLoggedIn ? <StyledXIcon onClick={handleClose} height={20} width={20} /> : null}
    </FlexCenHorVer>
  );
};
